<template>
    <div class="text-left">
        <p>Invite your friends to join your team by sending them this personalised link. If you have pre-paid for their
            tickets, you should instead invite them from your profile</p>
        <div class="alert alert-success" v-if="copied">
            Link copied. Now go share this link with your friends :-)
        </div>
        <copy-to-clipboard
            label="this is a label"
            :text-to-copy="link"
            @copied="onCopy"
        ></copy-to-clipboard>
    </div>
</template>

<script>
import CopyToClipboard from "../Utility/Buttons/CopyToClipboard.vue";

export default {
    name: "InviteToTeam",

    components: {
        CopyToClipboard,
    },

    props: {
        link: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            copied: false,
        }
    },

    methods: {
        onCopy() {
            Object.assign(this, {
                copied: true,
            });
            setInterval(() => {
                // this.$root.$emit('bv::hide::modal', 'teamInviteModal')
                Object.assign(this, {
                    copied: false,
                });
            }, 3000)
        }
    },
}

</script>



// WEBPACK FOOTER //
// src/Assets/components/Participants/InviteToTeam.vue